import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetchTeam } from "../../services/api";

const Team = () => {
  const { t, i18n } = useTranslation();
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchTeam()
      .then((data) => setMembers(data || []))
      .catch(() => setMembers([]));
  }, []);

  const getLocalized = (field) => {
    if (!field) return null;
    if (typeof field === "string") return field;
    const lang = i18n.language === "ua" ? "uk" : i18n.language;
    return field[lang] || field["uk"] || field["en"] || Object.values(field)[0] || null;
  };

  if (members.length === 0) return null;

  return (
    <div className="team-section" id="Team">
      <h1>{t("Team")}</h1>
      <div className="team-section-wrapper">
        {members.map((member) => (
          <div key={member.id} className="w-100 team-section-card">
            <img src={member.image_path} alt={getLocalized(member.name) || ""} />
            <div className="info">
              <h1>{getLocalized(member.name)}</h1>
              <p>{getLocalized(member.role)}</p>
            </div>
            <div className="about">
              <p>{getLocalized(member.description)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
